import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Selectable portfolio sort. Name-only by team decision — all tracked parents are curated by
 * upper management and equally important, so cart/severity/backlog sorting isn't offered. */
export type PortfolioSort = 'Name (A-Z)' | 'Name (Z-A)';
export const PORTFOLIO_SORT_OPTIONS: PortfolioSort[] = ['Name (A-Z)', 'Name (Z-A)'];

// Default state values — single source of truth.
const INITIAL_STATE = {
  offset: 0,
  pageSize: 25,
  sortBy: 'Name (A-Z)' as PortfolioSort,
} as const;

export interface CustomerHealthState {
  offset: number;
  pageSize: number;
  sortBy: PortfolioSort;

  setOffset: (offset: number) => void;
  setPageSize: (pageSize: number) => void;
  setSortBy: (sortBy: PortfolioSort) => void;
  resetPagination: () => void;
}

/** Persisted pagination/sort state for the Customer Health portfolio page — mirrors
 * `opportunityStore`. Changing page size or sort resets the offset to page 1. */
const useCustomerHealthStore = create<CustomerHealthState>()(
  persist(
    (set) => ({
      ...INITIAL_STATE,
      setOffset: (offset: number) => set({ offset }),
      setPageSize: (pageSize: number) => set({ pageSize, offset: 0 }),
      setSortBy: (sortBy: PortfolioSort) => set({ sortBy, offset: 0 }),
      resetPagination: () => set(INITIAL_STATE),
    }),
    {
      name: 'customer-health-storage',
      partialize: (state) => ({
        offset: state.offset,
        pageSize: state.pageSize,
        sortBy: state.sortBy,
      }),
    }
  )
);

export default useCustomerHealthStore;
